import { Context } from "@nuxt/types/app";

import getCountry from "./common.country.plugin";
import getCurrentPath from "./common.currentPath.plugin";
import getFormatErrorMessage from "./common.formatErrorMessage.plugin";
import getGeneratePassword from "./common.generatePassword.plugin";
import getShowErrorDialog from "./common.showErrorDialog.plugin";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function commonPlugin(context: Context) {
  const { generatePassword } = getGeneratePassword(context);
  const { currentPath } = getCurrentPath(context);
  const { country } = getCountry(context);
  const { formatErrorMessage } = getFormatErrorMessage(context);
  const { showErrorDialog } = getShowErrorDialog(context);

  return {
    generatePassword,
    currentPath,
    country,
    formatErrorMessage,
    showErrorDialog,
  };
}
